import React from "react";
import { StyledTableCell } from "./styles";

function TableCell(props) {
    return <StyledTableCell {...props} />;
}

export default TableCell;
